import React from 'react';

const EditableRow = ({ label, field, prefix, suffix, perColumnAssumptions, columnIds, onUpdate, defaultPerColumn }) => {
    const handleChange = (columnId, value) => {
        const num = value === '' ? 0 : parseFloat(value);
        onUpdate(columnId, field, isNaN(num) ? 0 : num);
    };

    const isModified = (columnId) =>
        defaultPerColumn?.[columnId] &&
        perColumnAssumptions[columnId]?.[field] !== defaultPerColumn[columnId][field];

    return (
        <>
            <div className="ct-label">{label}</div>
            {columnIds.map(id => (
                <div key={id} className="ct-cell ct-cell-editable">
                    <div className={`ct-input-wrap${isModified(id) ? ' modified' : ''}`}>
                        {prefix && <span className="ct-input-prefix">{prefix}</span>}
                        <input
                            type="number"
                            value={perColumnAssumptions[id]?.[field] || ''}
                            onChange={e => handleChange(id, e.target.value)}
                        />
                        {suffix && <span className="ct-input-suffix">{suffix}</span>}
                    </div>
                </div>
            ))}
        </>
    );
};

export default EditableRow;
